<template>
  <div class="ag-grafico-linha">
    <div class="ag-grafico-linha__title">{{ title }}</div>
    <ApexCharts
      class="ag-grafico-linha__chart"
      type="line"
      height="350"
      :options="mergedOptions"
      :series="mergedOptions.series"
    ></ApexCharts>
  </div>
</template>

<script>
import ModelGraficoLinha from '@/model/common/ModelGraficoLinha';
import { merge } from 'lodash';
import ApexCharts from 'vue3-apexcharts';

export default {
  components: {
    ApexCharts,
  },

  props: {
    options: {
      type: ModelGraficoLinha,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    defaultOptions: {
      chart: {
        type: 'line',
        locales: [{ name: 'pt-br' }],
        defaultLocale: 'pt-br',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        fontSize: '16px',
        horizontalAlign: 'left',
        fontFamily: 'Roboto',
        offsetY: 16,
      },
      stroke: {
        curve: 'straight',
      },
    },
  }),

  computed: {
    mergedOptions() {
      return merge({}, this.defaultOptions, this.options.fromModelToApexChart());
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-grafico-linha {
  width: 100%;

  .ag-grafico-linha__title {
    font-size: $font-size-sm;
  }

  .ag-grafico-linha__chart {
    padding-bottom: 16px;
  }
}

::v-deep(.apexcharts-tooltip) {
  border: 1px solid $neutral-color-high-light !important;
  box-shadow: $shadow-level-1;
  padding: 0 0 8px 0;
  .apexcharts-tooltip-title {
    text-align: center;
    background-color: $feedback-color-information-medium !important;
    color: $neutral-color-low-light;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .apexcharts-tooltip-series-group {
    padding: 0 16px;
    display: flex;
    align-items: center;
    .apexcharts-tooltip-marker {
      vertical-align: baseline;
    }
  }
}
</style>
